// extracted by mini-css-extract-plugin
export default {"root":"InventoryLicencesTable_root__NNUdR","quantity":"InventoryLicencesTable_quantity__K7WhG"};